import { useLocation, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { useQuery } from '~/common/routerUtils';

/** The search param an exported `civilgridUrl` carries. */
export const GEO_ITEM_SEARCH_PARAM = 'geoItem';

/**
 * Reads and writes `?geoItem=` on whichever project tab is mounted.
 *
 * No route in `routeTree.tsx` declares `validateSearch` — see the comment there — so the param is
 * read as a raw string and the rest of the query is carried through untouched.
 */
export function useGeoItemUrlParam() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const geoItemId = useQuery().get(GEO_ITEM_SEARCH_PARAM);

  const setGeoItemId = useCallback(
    (id: string | null) => {
      navigate({
        to: pathname,
        // Spread the router's parsed search rather than re-reading the raw query string: the
        // router re-serializes whatever it is handed, and raw strings that parse as JSON would
        // gain a layer of quotes on every write.
        search: (prev: Record<string, unknown>) => ({ ...prev, [GEO_ITEM_SEARCH_PARAM]: id ?? undefined }),
        // replace, so Back leaves the tab instead of stepping through every record opened on it.
        replace: true,
      });
    },
    [navigate, pathname],
  );

  return { geoItemId, setGeoItemId };
}
